
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Contact() {
  return (
    <div>
      <Header />
      {/* Hero Section Start */}
      <div 
        className="container-fluid" 
        style={{
          marginBottom: "90px",
          background: "linear-gradient(rgba(9, 30, 62, .7), rgba(9, 30, 62, .7)), url('/img/Contact us (1270 x 400).jpg') center center no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "60vh"
        }}>
        <div className="row py-5">
          <div className="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 className="display-4 text-white animated zoomIn">Contact Us</h1>
            <a href="/" className="h5 text-white">Home</a>
            <i className="far fa-circle text-white px-2"></i>
            <a href="/contact" className="h5 text-white">Contact</a>
          </div>
        </div>
      </div>
      {/* Hero Section End */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">Contact Us</h5>
                <h1 className="mb-0">Get In Touch With Our Team</h1>
              </div>
              <div className="row g-5">
                <div className="col-lg-7">
                  <div className="bg-primary rounded h-100 d-flex align-items-center p-5 wow zoomIn" data-wow-delay="0.9s">
                    <form>
                      <div className="row g-3">
                        <div className="col-xl-12">
                          <input
                            type="text"
                            className="form-control bg-light border-0"
                            placeholder="Your Name"
                            style={{height: "55px"}}/>
                        </div>
                        <div className="col-12">
                          <input
                            type="email"
                            className="form-control bg-light border-0"
                            placeholder="Your Email"
                            style={{height: "55px"}}/>
                        </div>
                        <div className="col-12">
                          <input
                            type="text"
                            className="form-control bg-light border-0"
                            placeholder="Subject"
                            style={{height: "55px"}}/>
                        </div>
                        <div className="col-12">
                          <textarea
                            className="form-control bg-light border-0"
                            rows="3"
                            placeholder="Message"
                          ></textarea>
                        </div>
                        <div className="col-12">
                          <button className="btn btn-dark w-100 py-3" type="submit">
                            Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="row g-5">
                    <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                      <div className="d-flex align-items-center mb-4">
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                          <i className="fa fa-map-marker-alt text-white fs-2"></i>
                        </div>
                        <div className="ps-4">
                          <h5 className="mb-2">Address</h5>
                          <h4 className="text-primary mb-0">CBD Building, Near Sharaf DG Metro Station, Dubai, UAE.</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                      <div className="d-flex align-items-center mb-4">
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                          <i className="fa fa-phone-alt text-white fs-2"></i>
                        </div>
                        <div className="ps-4">
                          <h5 className="mb-2">Phone</h5>
                          <h4 className="text-primary mb-0">+971 55 730 6504</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                      <div className="d-flex align-items-center mb-4">
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                          <i className="fa fa-envelope-open text-white fs-2"></i>
                        </div>
                        <div className="ps-4">
                          <h5 className="mb-2">Email</h5>
                          <h4 className="text-primary mb-0">info@brandliftmm.com</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;